import { openModal } from '../modal/modal';

const galleryJsClass = 'js-gallery';
const buttonJsClass = galleryJsClass + '-button';
const linkJsClass = galleryJsClass + '-link';

const galleryElements = document.querySelectorAll('.' + galleryJsClass) as NodeListOf<HTMLElement>;

galleryElements.forEach((galleryElement) => {
    const linkElement = galleryElement.querySelector('.' + linkJsClass) as HTMLElement;
    const ariaLabelledby = galleryElement.dataset.ariaLabelledby;
    const url = galleryElement.dataset.url;

    if (!linkElement || !url) {
        return;
    }

    // Add event listener on link to open modal
    linkElement.addEventListener('click', () => {
        openModal(linkElement, 0, url, ariaLabelledby);
    });

    // Get all buttons
    const buttonElements = galleryElement.querySelectorAll('.' + buttonJsClass) as NodeListOf<HTMLButtonElement>;

    buttonElements.forEach((buttonElement, index) => {
        // Add event listener on button to open modal
        buttonElement.addEventListener('click', () => {
            openModal(buttonElement, index, url, ariaLabelledby);
        });
    });
});